export enum IntegrationName {
  AuthorizeDotNet = 'authorizeDotNet',
  Adyen = 'adyen',
  Avalara = 'avalara',
  CrazyEgg = 'crazyegg',
  GoogleAnalytics = 'googleAnalytics',
  GreenSky = 'greenSky',
  Grove = 'grovePropertiesRTO',
  HubSpot = 'hubspot',
  HeartlandRTO = 'hci',
  MyShedRental = 'myshedrental',
  Pixel = 'pixel',
  RTONational = 'rtoNational',
  ServicePadRTO = 'servicepad',
  SharpSpring = 'sharpSpring',
  SMTP = 'smtp',
  Stripe = 'stripe',
  Zapier = 'zapier',
  ZipTax = 'zipTax',
}
